<template>
  <div class="premium-game-icon">
    <img :src="require('@/assets/games/premium-game-icon.png')" alt="">
    <span>Premium</span>
  </div>
</template>

<script>
export default {
  name: 'PremiumGameIcon',
};
</script>

<style lang="scss" scoped>
@import "@/scss/_breakpoints.scss";

.premium-game-icon {
  width: 68px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @include for-size(small-tablets-only-or-landscape) {
    width: 40px;
  }

  img {
    width: 50px;
    position: relative;
    top: 8px;

    @include for-size(small-tablets-only-or-landscape) {
      width: 40px;
      top: 0;
    }
  }
  span {
    background: #4255FF;
    border-radius: 15px;
    padding: 3px 5px;
    font-size: 12px;
    color: #fff;

    @include for-size(small-tablets-only-or-landscape) {
      display: none;
    }
  }
}
</style>
